import { render, staticRenderFns } from "./SurfaceBuilder.vue?vue&type=template&id=44188256&scoped=true&"
import script from "./SurfaceBuilder.vue?vue&type=script&lang=ts&"
export * from "./SurfaceBuilder.vue?vue&type=script&lang=ts&"
import style0 from "./SurfaceBuilder.vue?vue&type=style&index=0&id=44188256&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44188256",
  null
  
)

export default component.exports